export default {
    NEW: 'N',
    MODIFIED: 'M',
    DELETED: 'X'
}